/**
 * ปิดการแสดง console.log / debug / info โดยไม่ลบคำสั่งในไฟล์อื่น
 * - production: ปิดอัตโนมัติ
 * - ต้องการเปิดชั่วคราว: ใส่ REACT_APP_ENABLE_CONSOLE=true แล้ว rebuild
 */
(function silenceConsole() {
  const enabled =
    process.env.REACT_APP_ENABLE_CONSOLE === "true" ||
    process.env.NODE_ENV !== "production";

  if (enabled) return;

  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
})();
